module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAbCAMAAACkwzTUAAAAhFBMVEUAAAD/AACqAADGHBzMESLODCTKEiPMESLNEyXQEiTMEyXNEiTODybPESXNESXNECXPEibPECXNESXOESTOEiXOESXPESXNESXOESXNESXOESXOESXOESTNESXOESXNESXPESXOESXOESXOESbOESXOESXOESXOESXOESXOESXOESX///9Z/X+2AAAAKnRSTlMAAQMJDxUdHikrNzhDS0xSZW92d5Gms7S4ucHC0tPX2N3l7e7v9fb4+v6GUSi4AAAAAWJLR0QrJLnkCAAAAIFJREFUKM910kkSggAMRNF2QMQRxXlEUdR//wO6cgFps3yVSqXSkVo13NfXWRvzJ/BoWn8NAA0clwTtFm+CpkcIOr8TtLeCoNmZoJ3Fi6DJFoJObkQtPhitcLq0vX6ulGyc+n0lZSen/g5/biZpcHDqs5A0Kp36jH//UCn8zq6+TL8MJDbe5W/bKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/last.png
// module id = ZSG8
// module chunks = 2